import {isBooleanTrue} from '../../../@polygonjs/polygonjs/src/core/Type';
import {HistoryStack} from '../history/Stack';
import {StoreController} from '../store/controllers/StoreController';

export class WindowController {
	private static _instance: WindowController;
	private _eventCreated = false;
	private _uploadsInProgressCount: number = 0;
	private _sceneSavingInProgress: boolean = false;

	static instance() {
		return (this._instance = this._instance || new WindowController());
	}
	constructor() {}
	initEvent() {
		if (this._eventCreated) {
			return;
		}
		this._eventCreated = true;
		// https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
		window.addEventListener('beforeunload', (event) => {
			this.onbeforeunload(event);
		});
	}

	incrementUploadsInProgress() {
		this._uploadsInProgressCount += 1;
	}
	decrementUploadsInProgress() {
		this._uploadsInProgressCount -= 1;
	}
	markSceneSavingInProgress() {
		this._sceneSavingInProgress = true;
	}
	markSceneSavingCompleted() {
		this._sceneSavingInProgress = false;
	}
	sceneSavingInProgress() {
		return this._sceneSavingInProgress;
	}
	private _uploadsInProgress() {
		return this._uploadsInProgressCount > 0;
	}
	private _sceneModified(): boolean {
		return HistoryStack.instance().sceneModified();
	}
	promptRequired() {
		return (
			this._uploadsInProgress() ||
			(this._sceneModified() && !StoreController.scene.readOnly()) ||
			isBooleanTrue(this._sceneSavingInProgress)
		);
	}
	private onbeforeunload(event: BeforeUnloadEvent) {
		// If we are on the desktop, it's better to have the desktop app handle this event.
		// If it was handled here, this would attempt to create an alert popup,
		// but such popup does not work on electron, so it appears as if nothing happens,
		// and to the user it simply looks like the app refuses to close.
		// if (DesktopController.instance().active()) {
		// 	return;
		// }
		if (this.promptRequired()) {
			event.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
			// Chrome requires returnValue to be set
			event.returnValue = '';
		}
	}
}
